import React, { useEffect, useRef } from 'react'

import { useEditor } from '@toasttab/sites-components'
import classnames from 'classnames'

import PreviewModeBanner from 'shared/components/common/nav/preview_mode_banner/PreviewModeBanner'
import { t } from 'src/translations'

import { useGlobalNav } from 'public/components/default_template/GlobalNavContext'
import { useSpotlightContext } from 'public/components/default_template/spotlight/SpotlightContext'

export type NavType = 'normal' | 'stickyNav' | 'fixedNav' | 'absoluteNav'

type Props = {
  navType: NavType
  shouldShowPreviewBanner: boolean
  className?: string
}

const GlobalNav = (props: React.PropsWithChildren<Props>) => {
  const { setGlobalNavHeight, globalNavOpen, globalNavHeight } = useGlobalNav()
  const { isHidden } = useSpotlightContext()
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (ref.current) {
      const height = ref.current.getBoundingClientRect().height
      setGlobalNavHeight(height)
    }
  }, [setGlobalNavHeight, isHidden])

  const { isEditor } = useEditor()
  return (
    <nav
      className={classnames(
        'globalNav',
        globalNavOpen ? props.navType : 'fixedNav', // when the nav is closed, enforce a fixed position out of view
        props.className
      )}
      id='globalNav'
      aria-label={t('nav.main-navigation')}
      ref={ref}
      style={!globalNavOpen ? { top: `-${globalNavHeight}px` } : undefined}
    >
      {!isEditor && <PreviewModeBanner {...props} />}
      {props.children}
    </nav>
  )
}

export default GlobalNav
